import * as React from 'react';
import { ReactComponent as QRCodeIconSVG } from '../../assets/icons/mevo/ic_qr_code.svg';
import IconPattern, { IconProps } from './_IconPattern';

const QRCodeIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={QRCodeIconSVG} variantPlaces={2} {...props} />;
};

export default QRCodeIcon;
